export default __webpack_public_path__ + "static/media/connecting.f91c4887.svg";